function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBar = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _Button = require("../Button");
var Icons = _interopRequireWildcard(require("../Icons"));
var _Logo = require("../Logo");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onBackButtonPress", "offsetY", "showBackButton", "backButtonLabel", "style", "logoLinkUrl"],
  _excluded2 = ["style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var TopBar = exports.TopBar = function TopBar(_ref) {
  var onBackButtonPress = _ref.onBackButtonPress,
    _ref$offsetY = _ref.offsetY,
    offsetY = _ref$offsetY === void 0 ? new _reactNative.Animated.Value(0) : _ref$offsetY,
    _ref$showBackButton = _ref.showBackButton,
    showBackButton = _ref$showBackButton === void 0 ? false : _ref$showBackButton,
    backButtonLabel = _ref.backButtonLabel,
    style = _ref.style,
    logoLinkUrl = _ref.logoLinkUrl,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _hasLogoLinkUrl = !!logoLinkUrl;
  var BackArrow = (0, _react.memo)(function (_ref2) {
    var style = _ref2.style,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
    var _scale = _reactNative.Platform.OS === 'web' ? 0.7 : 1;
    return (0, _jsxRuntime.jsx)(Icons.BackArrow, Object.assign({}, props, {
      style: [style, {
        transform: [{
          scale: _scale
        }]
      }]
    }));
  });
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    style: [styles.container, style],
    testID: "TopBar"
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_reactNative.Animated.View, {
      style: [styles.background, {
        opacity: offsetY.interpolate({
          inputRange: [0, 100],
          outputRange: [0, 1],
          extrapolate: 'clamp'
        })
      }]
    }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.topBar,
      children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
        style: styles.backButton,
        children: showBackButton && (0, _jsxRuntime.jsx)(_Button.Button, {
          label: backButtonLabel,
          onPress: onBackButtonPress,
          hideLabel: true,
          type: _Button.ButtonType.icon,
          icon: BackArrow,
          testID: "BackButton"
        })
      }), _hasLogoLinkUrl ? (0, _jsxRuntime.jsx)(_Button.Button, {
        href: logoLinkUrl,
        type: _Button.ButtonType.blank,
        textStyle: styles.logoLink,
        label: "logo",
        children: (0, _jsxRuntime.jsx)(_Logo.Logo, {
          style: styles.logo,
          testID: "Logo"
        })
      }) : (0, _jsxRuntime.jsx)(_Logo.Logo, {
        style: styles.logo,
        testID: "Logo"
      })]
    })]
  }));
};